import api from './api';

const preInscricaoStatusService = {
  async atualizarStatus(preInscricaoId, novoStatus, observacao = '') {
    try {
      const response = await api.put(`/pre-inscricoes-status/${preInscricaoId}/status`, {
        novoStatus,
        observacao
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar status:', error);
      throw error;
    }
  },

  async obterHistorico(preInscricaoId) {
    try {
      const response = await api.get(`/pre-inscricoes-status/${preInscricaoId}/historico`);
      return response.data;
    } catch (error) {
      console.error('Erro ao obter histórico:', error);
      throw error;
    }
  },

  async obterEstatisticas(instituicaoId) {
    try {
      const response = await api.get(`/pre-inscricoes-status/estatisticas/${instituicaoId}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao obter estatísticas:', error);
      throw error;
    }
  }
};

export default preInscricaoStatusService;